module.exports = __webpack_public_path__ + "img/tree14.6266a00c.png";